module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/addressing_desktop-756389fa9e678623c3c82ecc77f195ac.png";